import { SectionHeading } from "./get-your-fans/section-heading"
import { ContentParagraph } from "./get-your-fans/content-paragraph"
import { MobileGetYourFansImage } from "./get-your-fans/mobile-get-your-fans-image"
import { DesktopGetYourFansImage } from "./get-your-fans/desktop-get-your-fans-image"
export function GetYourFansSection() {
  return (
    <div className="relative w-full justify-center bg-black py-8 md:px-16 md:py-16 md:pb-0">
      <div className="relative mx-auto w-full max-w-7xl md:flex md:flex-row md:px-0">
        <div className="flex flex-1 flex-col md:pb-8">
          <div className="flex flex-col items-center justify-center px-4 xs:px-8 md:max-w-2xl md:items-start md:justify-start md:px-0">
            <SectionHeading
              firstLine="Get your Fans In THE"
              secondLine="Group Chat"
              highlightSecond={true}
            />
            <MobileGetYourFansImage />
          </div>

          <div className="flex flex-col gap-4 px-8 pt-6 md:px-0">
            <ContentParagraph>
              Host a group chat on any topic, from podcasts and TV shows to sports, politics,
              comedy, tech, and more.
            </ContentParagraph>
            <ContentParagraph>
              Chat away, share exclusive content, interact with your audience, and{" "}
              <strong className="font-bold">build a thriving, always-on community.</strong>
            </ContentParagraph>
          </div>
        </div>
        <div className="flex flex-1 md:mb-[-64px]">
          <DesktopGetYourFansImage />
        </div>
      </div>
    </div>
  )
}
